import { useSearchParams } from 'react-router-dom'
import ComingSoon from '../components/ComingSoon'

export default function Search() {
  const [params] = useSearchParams()
  const role = params.get('role')
  return (
    <ComingSoon
      title={role ? `Search · ${role}` : 'Search'}
      subtitle="Filter players, agents, and coaches"
    />
  )
}
